<template>
    <div class="page">
        <div class="about-container">
            <div class="about-container-left">
                <img src="@/assets/Tiia.jpg" alt="Tiia face picture">
            </div>
            <div class="about-container-right">
                <p>
                    Minua on aina kiinnostanut ihmisten auttaminen.
                    Ehkä sitä voi kutsua jonkinlaiseksi ”kutsumukseksi”, vaikka en sanasta niin välitäkään.
                    Ensimmäinen ammattini oli lähihoitaja mielenterveys- ja päihdetyössä.
                    Näitä töitä tein hetken aikaa, mutta halusin päästä kliinisempään ympäristöön ja tekemään jotain ihan muuta. Opiskelin sairaanhoitajaksi ja erikoistuin perioperatiiviseen hoitotyöhön.
                    Päädyin Töölön sairaalan ortopedian- ja traumatologian leikkaussaliin anestesiahoitajaksi.
                    Pidin anestesihoitajan työstä todella paljon. Töölö oli hyvin mielenkiintoinen ja haastava ensimmäinen leikkaussali työpaikka.
                    Tuntui kuitenkin, että jotain puuttui. Halusin auttaa ihmisiä kokonaisvaltaisemmin ja päädyin opiskelemaan kiinalaista lääketiedettä.
                </p>
            </div>
            <div class="about-container-bottom">
                <p>
                    Aloitin opinnot Kiinalaisen lääketieteen Akatemiassa 2019 ja tein siinä samalla anestesiasairaanhoitajan töitä osa-aikaisesti.
                    Saimme perheenlisäystä loppuvuodesta 2020 ja jäin äitiyslomalle sekä töistä että koulusta.
                    Opinnot kestivät 3,5 vuotta ja valmistuin kesäkuussa 2025.
                    Kiinalaisen lääketieteen Akatemia on Suomen laajin kiinalaisen lääketieteen ja akupunktion koulutus. Opinnot täyttävät WHO:n ja ETCMA:n asettamat koulutuskriteerit.
                    Omia mielenkiinnon kohteitani ovat arpihoidot sekä erilaiset akuutit ja krooniset kivut. Olenkin syventänyt osaamistani tulineula- ja motorisen akupunktionkurssilla, jotka ovat antaneet lisää työkaluja monipuolisten hoitojen tekemiseen.
                </p>
                <p>
                    Kiinalaisessa lääketieteessä minut tempaisi mukaansa sen kokonaisvaltaisuus ja loputtomat mahdollisuudet.
                    Minusta hienointa on, että vaihtoehtohoidot avaavat mahdollisuuksia myös ihmisille, joiden kohdalla länsimainen lääketiede on nostanut kätensä pystyyn.
                    Saatat kärsiä oireista, joille ei ole löytynyt tutkimuksista huolimatta syytä.
                    Olet saattanut kokea väheksyntää oireidesi takia tai olet muuten vain tyytymätön saamaasi hoitoon.
                    Haitpa sitten apua pitkäaikaisille oireille, hetkeä omalle hyvinvoinnille tai koet muuten mielenkiintoa kiinalaista lääketiedettä kohtaan, olet aina tervetullut Koliklinikalle.
                    Koliklinikalla hoitotilanne on kiireetön ja aidolle vuorovaikutukselle on aikaa. Tule sellaisena kuin olet!
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AboutPage'
    };
</script>

<style scoped>
    .about-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .about-container-left {
        flex: 1;
        display: flex;
        gap: 20px;
        justify-content: center;
    }

    .about-container-right {
        flex: 1;
        display: flex;
        gap: 20px;
        flex-direction: column;
        justify-content: center;
    }

        .about-container-left img {
            width: 65%;
            height: auto;
            object-fit: cover;
            border-radius: 8px;
        }

    .about-container-bottom  {
        margin: 20px 0px 20px 0px;
    }

    @media (max-width: 768px) {
        .about-container {
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;
        }

        .about-container-right {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
</style>
